import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const DsrTypeAccess: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M31.6667 11.5667H20.8817C20.33 11.5667 19.8133 11.2934 19.5033 10.8367L17.1617 7.39508C16.8517 6.94008 16.3367 6.66675 15.785 6.66675H8.33333C6.49167 6.66675 5 8.15841 5 10.0001V30.0001C5 31.8417 6.49167 33.3334 8.33333 33.3334H31.6667C33.5083 33.3334 35 31.8417 35 30.0001V14.9001C35 13.0601 33.5083 11.5667 31.6667 11.5667Z"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 26.6668V18.3335"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.125 23.5417L20 26.6667L16.875 23.5417"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
